import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const SINAV_TURLERI = ['Sayısal', 'Eşitağırlık', 'Sözel', 'Dil', 'LGS', 'Okula Destek', 'Bursluluk', 'TYT'];

export default function OgrencilerPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const location = useLocation();
  const [ogrenciler, setOgrenciler] = useState([]);
  const [siniflar, setSiniflar] = useState([]);
  const [rehberler, setRehberler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [arama, setArama] = useState('');
  const [sinifFilter, setSinifFilter] = useState('');
  const [sayfa, setSayfa] = useState(1);
  const [pagination, setPagination] = useState({});

  const [showModal, setShowModal] = useState(false);
  const [showDetay, setShowDetay] = useState(null);
  const [showCredentialsModal, setShowCredentialsModal] = useState(false);
  const [generatedCredentials, setGeneratedCredentials] = useState(null);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  // '' = hepsi, '1' = sadece aktif, '0' = sadece pasif
  const [aktifFilter, setAktifFilter] = useState('');

  const [form, setForm] = useState({
    ad: '', soyad: '', email: '', telefon: '', sifre: 'Ogrenci123!',
    sinif_id: '', dogum_tarihi: '', hedef_universite: '', hedef_bolum: '',
    hedef_net: 0, hedef_puan: 0, sinav_turu: 'TYT',
    veli_ad: '', veli_soyad: '', veli_telefon: '', rehber_ogretmen_id: ''
  });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ sayfa, limit: 15 });
      if (arama) params.append('arama', arama);
      if (sinifFilter) params.append('sinif_id', sinifFilter);
      // aktifFilter '' ise parametre gönderme → backend tüm öğrencileri döner
      if (aktifFilter !== '') params.append('aktif', aktifFilter);

      const [ogrRes, sinifRes, rehberRes] = await Promise.all([
        axios.get(`/ogrenciler?${params}`),
        axios.get('/siniflar'),
        axios.get('/users?rol=rehber_ogretmen&limit=500'),
      ]);
      if (ogrRes.data.success) { setOgrenciler(ogrRes.data.data); setPagination(ogrRes.data.pagination || {}); }
      if (sinifRes.data.success) setSiniflar(sinifRes.data.data);
      if (rehberRes.data.success) setRehberler(rehberRes.data.data || []);
    } catch (e) { toast.error('Yükleme hatası'); }
    finally { setLoading(false); }
  }, [arama, sinifFilter, aktifFilter, sayfa]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sinifId = params.get('sinif_id') || '';
    const yeni = params.get('new');
    if (sinifId) {
      setSinifFilter(sinifId);
      setForm(prev => ({ ...prev, sinif_id: sinifId }));
    }
    if (yeni === '1') setShowModal(true);
  }, [location.search]);

  const handleCreate = async () => {
    if (!form.ad || !form.soyad) { toast.error('Ad ve soyad zorunlu'); return; }
    if (!form.sinif_id) { toast.error('Sınıf seçimi zorunlu'); return; }
    if (!form.veli_ad || !form.veli_soyad || !form.veli_telefon) {
      toast.error('Veli ad, soyad ve telefon zorunlu');
      return;
    }
    try {
      const payload = {
        rol: 'ogrenci',
        ad: form.ad,
        soyad: form.soyad,
        telefon: form.telefon || null,
        extra: {
          sinif_id: form.sinif_id,
          sinav_turu: form.sinav_turu,
          veli_ad: form.veli_ad,
          veli_soyad: form.veli_soyad,
          veli_telefon: form.veli_telefon,
          rehber_ogretmen_id: form.rehber_ogretmen_id || null,
          hedef_net: form.hedef_net,
          hedef_puan: form.hedef_puan,
          hedef_universite: form.hedef_universite,
          hedef_bolum: form.hedef_bolum
        },
      };
      const { data } = await axios.post('/users', payload);
      const createdData = data?.data || {};
      const creds = createdData?.generated_credentials || {};
      setGeneratedCredentials({
        ogrenci_no: createdData?.ogrenci_no || null,
        ogrenci_email: creds?.ogrenci_email || null,
        ogrenci_sifre: creds?.ogrenci_sifre || null,
        veli_email: creds?.veli_email || null,
        veli_sifre: creds?.veli_sifre || null,
      });
      setShowCredentialsModal(true);
      toast.success('Öğrenci eklendi!');
      setShowModal(false);
      setForm({ ad: '', soyad: '', email: '', telefon: '', sifre: 'Ogrenci123!', sinif_id: '', dogum_tarihi: '', hedef_universite: '', hedef_bolum: '', hedef_net: 0, hedef_puan: 0, sinav_turu: 'TYT', veli_ad: '', veli_soyad: '', veli_telefon: '', rehber_ogretmen_id: '' });
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'Hata'); }
  };

  const handleEdit = async () => {
    if (!showDetay) return;
    try {
      await axios.put(`/ogrenciler/${showDetay.id}`, {
        ...showDetay,
        rehber_ogretmen_id: showDetay.rehber_ogretmen_id || showDetay.rehber_id || null,
      });
      toast.success('Öğrenci ve Veli başarıyla güncellendi! ✓');
      setShowDetay(null);
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'Güncelleme hatası'); }
  };

  // Pasife al (soft delete) — DELETE /ogrenciler/:id
  const handlePasife = async (id) => {
    if (!window.confirm('Bu öğrenciyi pasife almak istediğinizden emin misiniz?')) return;
    try {
      await axios.delete(`/ogrenciler/${id}`);
      toast.success('Öğrenci pasife alındı ✓');
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'İşlem başarısız'); }
  };

  // Aktife al — PATCH /ogrenciler/:id/aktife-al
  const handleAktife = async (id) => {
    try {
      await axios.patch(`/ogrenciler/${id}/aktife-al`);
      toast.success('Öğrenci aktife alındı ✓');
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'İşlem başarısız'); }
  };

  // Kalıcı sil — DELETE /ogrenciler/:id/kalici
  const handleHardDelete = async (id, adSoyad) => {
    if (!window.confirm(`⚠️ "${adSoyad}" adlı öğrenci KALICI olarak silinecek, geri alınamaz! Emin misiniz?`)) return;
    if (!window.confirm('Son onay: Tüm sınav, yoklama ve ilişkili veriler de silinecek!')) return;
    try {
      await axios.delete(`/ogrenciler/${id}/kalici`);
      toast.success('Öğrenci kalıcı olarak silindi');
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'Silme başarısız'); }
  };

  const handleExport = async () => {
    try {
      const res = await axios.get('/export/ogrenciler', { responseType: 'blob' });
      const url = window.URL.createObjectURL(res.data);
      const a = document.createElement('a'); a.href = url; a.download = 'ogrenciler.xlsx'; a.click();
      toast.success('Excel indirildi!');
    } catch { toast.error('Export hatası'); }
  };

  const handleExcelSubmit = async () => {
    if (!excelFile) return toast.error('Lütfen bir Excel dosyası seçin!');
    const formData = new FormData();
    formData.append('excelFile', excelFile);
    setIsUploading(true);
    toast.loading('Excel işleniyor, lütfen bekleyin...', { id: 'excel-upload' });
    try {
      const res = await axios.post('/ogrenciler/excel-yukle', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(res.data.message || 'Öğrenciler başarıyla aktarıldı!', { id: 'excel-upload' });
      setShowExcelModal(false);
      setExcelFile(null);
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Yükleme başarısız oldu.', { id: 'excel-upload' });
    } finally {
      setIsUploading(false);
    }
  };

  const getKayitTarihi = (ogrenci) => {
    const raw =
      ogrenci?.kayit_tarihi || ogrenci?.kayitTarihi || ogrenci?.kayit_tarih ||
      ogrenci?.created_at || ogrenci?.createdAt || ogrenci?.olusturma_tarihi ||
      ogrenci?.user_created_at || ogrenci?.user?.created_at;
    if (!raw) return '—';
    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) return '—';
    return parsed.toLocaleDateString('tr-TR');
  };

  // Filtre butonu etiket & renk yardımcısı
  const aktifFilterLabel = aktifFilter === '1' ? '✅ Sadece Aktif' : aktifFilter === '0' ? '🔒 Sadece Pasif' : '👁 Tümü';
  const aktifFilterBg    = aktifFilter === '0' ? '#FEF3C7' : aktifFilter === '1' ? '#D1FAE5' : 'var(--bg-elevated)';
  const aktifFilterColor = aktifFilter === '0' ? '#92400E'  : aktifFilter === '1' ? '#065F46'  : 'var(--text-muted)';

  const cycleAktifFilter = () => {
    // '' → '1' → '0' → '' döngüsü
    setAktifFilter(v => v === '' ? '1' : v === '1' ? '0' : '');
    setSayfa(1);
  };

  return (
    <div className="ogrenciler-page-container" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{`
        @media (max-width: 1024px) {
          .section-header { flex-direction: column; align-items: flex-start !important; gap: 15px; }
          .section-header div:last-child { width: 100%; justify-content: space-between; }
          .table-container table, .table-container thead, .table-container tbody,
          .table-container th, .table-container td, .table-container tr { display: block; }
          .table-container thead tr { position: absolute; top: -9999px; left: -9999px; }
          .table-container tr {
            border: 1px solid var(--border); border-radius: 12px; margin-bottom: 15px;
            padding: 10px; background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.02);
          }
          .table-container td {
            border: none; position: relative; padding-left: 45% !important;
            text-align: right !important; min-height: 40px; display: flex;
            align-items: center; justify-content: flex-end; border-bottom: 1px solid #f8f9fa;
          }
          .table-container td:last-child { border-bottom: none; }
          .table-container td:before {
            position: absolute; left: 12px; width: 40%; white-space: nowrap;
            text-align: left; font-weight: 600; color: var(--text-muted);
            content: attr(data-label); font-size: 0.75rem; text-transform: uppercase;
          }
          .table-container td div { justify-content: flex-end; }
          .modal { width: 95% !important; margin: 10px; padding: 15px !important; }
          .modal div[style*="gridTemplateColumns"] { grid-template-columns: 1fr !important; }
        }
        tr.pasif-satir { opacity: 0.65; background: #fafafa; }
      `}</style>

      {/* BAŞLIK */}
      <div className="section-header animate-fadeInUp" style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: isMobile ? 'stretch' : 'center',
        flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? 12 : 0
      }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>🎓 Öğrenci Yönetimi</h2>
          <div className="section-subtitle">{pagination.total || 0} öğrenci</div>
        </div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <button className="btn btn-ghost btn-sm" onClick={handleExport}>📊 Dışa Aktar</button>
          <button className="btn btn-outline" style={{ borderColor: '#10B981', color: '#10B981' }} onClick={() => setShowExcelModal(true)}>
            📂 Toplu Yükle
          </button>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Yeni Öğrenci</button>
        </div>
      </div>

      {/* FİLTRELER */}
      <div className="card animate-fadeInUp stagger-1" style={{ padding: isMobile ? '14px' : '16px 20px' }}>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row' }}>
          <input
            className="form-input"
            placeholder="🔍 Ad, soyad veya numara..."
            value={arama}
            onChange={(e) => { setArama(e.target.value); setSayfa(1); }}
            style={{ flex: 1, minWidth: isMobile ? '100%' : '200px' }}
          />
          <select
            className="form-select"
            value={sinifFilter}
            onChange={e => { setSinifFilter(e.target.value); setSayfa(1); }}
            style={{ minWidth: isMobile ? '100%' : '150px', flex: 1 }}
          >
            <option value="">Tüm Sınıflar</option>
            {(siniflar || []).map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
          </select>

          {/* Aktif / Pasif / Tümü döngüsel filtre */}
          <button
            className="btn btn-sm"
            style={{
              background: aktifFilterBg,
              color: aktifFilterColor,
              border: '1px solid var(--border)',
              whiteSpace: 'nowrap',
              fontWeight: 600,
            }}
            onClick={cycleAktifFilter}
            title="Tıklayarak: Tümü → Sadece Aktif → Sadece Pasif → Tümü"
          >
            {aktifFilterLabel}
          </button>
        </div>
      </div>

      {/* TABLO */}
      <div className="card animate-fadeInUp stagger-2" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Öğrenci</th>
                <th>Numara</th>
                <th>Sınıf</th>
                <th>Sınav</th>
                <th>Hedef Net</th>
                <th>Veli</th>
                <th>Kayıt</th>
                <th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill(0).map((_, i) => (
                  <tr key={i}>
                    {Array(8).fill(0).map((_, j) => (
                      <td key={j}><div className="skeleton" style={{ height: 18, borderRadius: 6, width: '100%' }} /></td>
                    ))}
                  </tr>
                ))
              ) : ogrenciler.length === 0 ? (
                <tr><td colSpan={8}>
                  <div className="empty-state" style={{ padding: 40, textAlign: 'center' }}>
                    <div style={{ fontSize: '2rem' }}>🔍</div>
                    <h3>Öğrenci bulunamadı</h3>
                  </div>
                </td></tr>
              ) : ogrenciler.map((o, i) => {
                const isPasif = o.aktif == 0;
                return (
                  <tr key={i} className={isPasif ? 'pasif-satir' : ''}>
                    <td data-label="Öğrenci">
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div
                          className="avatar avatar-sm"
                          style={{
                            background: isPasif ? 'rgba(156,163,175,0.2)' : 'rgba(6,182,212,0.15)',
                            color: isPasif ? '#9CA3AF' : '#06B6D4',
                            flexShrink: 0
                          }}
                        >
                          {o.ad?.[0]}{o.soyad?.[0]}
                        </div>
                        <div style={{ textAlign: 'left' }}>
                          <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
                            {o.ad} {o.soyad}
                            {isPasif && (
                              <span className="badge" style={{ background: '#FEF3C7', color: '#92400E', fontSize: '0.65rem' }}>
                                PASİF
                              </span>
                            )}
                          </div>
                          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{o.telefon || o.email}</div>
                        </div>
                      </div>
                    </td>
                    <td data-label="Numara"><span className="badge badge-muted">{o.ogrenci_no}</span></td>
                    <td data-label="Sınıf">{o.sinif_adi || '—'}</td>
                    <td data-label="Sınav"><span className="badge badge-info">{o.sinav_turu}</span></td>
                    <td data-label="Hedef Net">
                      <span style={{ fontWeight: 700, color: 'var(--accent)' }}>{o.hedef_net > 0 ? o.hedef_net : '—'}</span>
                    </td>
                    <td data-label="Veli">
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontWeight: 600 }}>{o.veli_ad ? `${o.veli_ad} ${o.veli_soyad || ''}` : '—'}</div>
                        {o.veli_telefon && <div style={{ fontSize: '0.72rem' }}>📞 {o.veli_telefon}</div>}
                      </div>
                    </td>
                    <td data-label="Kayıt">{getKayitTarihi(o)}</td>
                    <td data-label="İşlem">
                      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                        {/* Detay */}
                        <button
                          className="btn btn-outline btn-sm"
                          title="Detay"
                          onClick={() => navigate(`/admin/ogrenciler/${o.id}`)}
                        >🔍</button>

                        {/* Düzenle */}
                        <button
                          className="btn btn-sm"
                          title="Düzenle"
                          style={{ background: '#EFF6FF', color: 'var(--blue)' }}
                          onClick={() => setShowDetay(o)}
                        >✏️</button>

                        {/* Aktif / Pasif toggle */}
                        {isPasif ? (
                          <button
                            className="btn btn-sm"
                            title="Aktife al"
                            style={{ background: '#D1FAE5', color: '#065F46' }}
                            onClick={() => handleAktife(o.id)}
                          >✅</button>
                        ) : (
                          <button
                            className="btn btn-sm"
                            title="Pasife al"
                            style={{ background: '#FEF3C7', color: '#92400E' }}
                            onClick={() => handlePasife(o.id)}
                          >🔒</button>
                        )}

                        {/* Kalıcı sil */}
                        <button
                          className="btn btn-sm"
                          title="Kalıcı sil"
                          style={{ background: 'var(--danger-dim)', color: 'var(--danger)' }}
                          onClick={() => handleHardDelete(o.id, `${o.ad} ${o.soyad}`)}
                        >🗑</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* SAYFALAMA */}
        {pagination.toplam_sayfa > 1 && (
          <div style={{
            padding: '14px 16px', borderTop: '1px solid var(--border)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            flexWrap: 'wrap', gap: 10
          }}>
            <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
              Sayfa {sayfa} / {pagination.toplam_sayfa} — Toplam {pagination.total} öğrenci
            </span>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-ghost btn-sm" disabled={sayfa === 1} onClick={() => setSayfa(s => s - 1)}>←</button>
              <button className="btn btn-ghost btn-sm" disabled={sayfa >= pagination.toplam_sayfa} onClick={() => setSayfa(s => s + 1)}>→</button>
            </div>
          </div>
        )}
      </div>

      {/* EXCEL MODAL */}
      {showExcelModal && (
        <div className="modal-backdrop" onClick={() => !isUploading && setShowExcelModal(false)}>
          <div className="modal" style={{ maxWidth: 500, width: '100%', padding: isMobile ? 16 : 24 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">📂 Excel ile Toplu Kayıt</div>
              {!isUploading && <button className="modal-close" onClick={() => setShowExcelModal(false)}>✕</button>}
            </div>
            <div style={{ padding: '10px 0' }}>
              <div style={{ background: 'var(--bg-elevated)', padding: 12, borderRadius: 8, marginBottom: 20, fontSize: '0.85rem' }}>
                <strong>⚠️ Format:</strong> OgrenciNo | Ad | Soyad | Telefon | VeliAd | VeliSoyad | VeliTel | SinifAdi | SinavTuru | HedefNet
              </div>
              <input type="file" accept=".xlsx, .xls" className="form-input" disabled={isUploading} onChange={(e) => setExcelFile(e.target.files[0])} />
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20, flexDirection: isMobile ? 'column' : 'row' }}>
              <button className="btn btn-primary" style={{ flex: 1, background: '#10B981' }} onClick={handleExcelSubmit} disabled={isUploading || !excelFile}>
                {isUploading ? 'Yükleniyor...' : '✓ Yükle'}
              </button>
              <button className="btn btn-secondary" onClick={() => setShowExcelModal(false)}>İptal</button>
            </div>
          </div>
        </div>
      )}

      {/* DÜZENLE MODAL */}
      {showDetay && (
        <div className="modal-backdrop" onClick={() => setShowDetay(null)}>
          <div className="modal" style={{ maxWidth: 640, width: '100%', padding: isMobile ? 16 : 24 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">✏️ Düzenle: {showDetay.ad} {showDetay.soyad}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14, maxHeight: '60vh', overflowY: 'auto' }}>
              <div className="form-group"><label className="form-label">Ad</label><input className="form-input" value={showDetay.ad || ''} onChange={e => setShowDetay({ ...showDetay, ad: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Soyad</label><input className="form-input" value={showDetay.soyad || ''} onChange={e => setShowDetay({ ...showDetay, soyad: e.target.value })} /></div>
              <div className="form-group"><label className="form-label">Sınıf</label>
                <select className="form-input" value={showDetay.sinif_id || ''} onChange={e => setShowDetay({ ...showDetay, sinif_id: e.target.value })}>
                  {siniflar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
                </select>
              </div>
              <div className="form-group"><label className="form-label">Sınav Türü</label>
                <select className="form-input" value={showDetay.sinav_turu || 'TYT'} onChange={e => setShowDetay({ ...showDetay, sinav_turu: e.target.value })}>
                  {SINAV_TURLERI.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div className="form-group" style={{ gridColumn: isMobile ? 'auto' : '1 / -1' }}>
                <label className="form-label">Rehber Öğretmen</label>
                <select
                  className="form-input"
                  value={showDetay.rehber_ogretmen_id || showDetay.rehber_id || ''}
                  onChange={e => setShowDetay({ ...showDetay, rehber_ogretmen_id: e.target.value })}
                >
                  <option value="">Seçiniz</option>
                  {rehberler.map(r => <option key={r.id} value={r.id}>{r.ad} {r.soyad}</option>)}
                </select>
              </div>
              <div style={{ gridColumn: '1/-1', borderTop: '1px solid #eee', paddingTop: 10 }}>
                <div className="form-group">
                  <label className="form-label">Veli Telefon</label>
                  <input className="form-input" value={showDetay.veli_telefon || ''} onChange={e => setShowDetay({ ...showDetay, veli_telefon: e.target.value })} />
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20, flexDirection: isMobile ? 'column' : 'row' }}>
              <button className="btn btn-primary" style={{ flex: 1 }} onClick={handleEdit}>✓ Güncelle</button>
              <button className="btn btn-outline" onClick={() => setShowDetay(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {/* YENİ KAYIT MODAL */}
      {showModal && (
        <div className="modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="modal" style={{ maxWidth: 700, width: '100%', padding: isMobile ? 16 : 24 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><div className="modal-title">🎓 Yeni Öğrenci</div></div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 14, maxHeight: '60vh', overflowY: 'auto' }}>
              {[
                { k: 'ad', l: 'Ad *' }, { k: 'soyad', l: 'Soyad *' },
                { k: 'telefon', l: 'Telefon' }, { k: 'veli_ad', l: 'Veli Ad *' },
                { k: 'veli_soyad', l: 'Veli Soyad *' }, { k: 'veli_telefon', l: 'Veli Telefon *' },
                { k: 'hedef_net', l: 'Hedef Net', t: 'number' }
              ].map(f => (
                <div className="form-group" key={f.k}>
                  <label className="form-label">{f.l}</label>
                  <input className="form-input" type={f.t || 'text'} value={form[f.k]} onChange={e => setForm({ ...form, [f.k]: e.target.value })} />
                </div>
              ))}
              <div className="form-group">
                <label className="form-label">Sınıf</label>
                <select className="form-select" value={form.sinif_id} onChange={e => setForm({ ...form, sinif_id: e.target.value })}>
                  <option value="">Seçiniz</option>
                  {siniflar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Rehber Öğretmen</label>
                <select className="form-select" value={form.rehber_ogretmen_id} onChange={e => setForm({ ...form, rehber_ogretmen_id: e.target.value })}>
                  <option value="">Seçiniz</option>
                  {rehberler.map(r => <option key={r.id} value={r.id}>{r.ad} {r.soyad}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20, flexDirection: isMobile ? 'column' : 'row' }}>
              <button className="btn btn-primary" style={{ flex: 1 }} onClick={handleCreate}>✓ Kaydet</button>
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
            </div>
          </div>
        </div>
      )}

      {/* KREDENSİYEL MODAL */}
      {showCredentialsModal && generatedCredentials && (
        <div className="modal-backdrop" onClick={() => setShowCredentialsModal(false)}>
          <div className="modal" style={{ maxWidth: 640, width: '100%', padding: isMobile ? 16 : 24 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">🔑 Otomatik Hesap Bilgileri</div>
              <button className="modal-close" onClick={() => setShowCredentialsModal(false)}>✕</button>
            </div>
            <div style={{ display: 'grid', gap: 10, marginTop: 6 }}>
              {[
                { label: 'Öğrenci No', value: generatedCredentials.ogrenci_no },
                { label: 'Öğrenci E-posta', value: generatedCredentials.ogrenci_email },
                { label: 'Öğrenci Şifre', value: generatedCredentials.ogrenci_sifre },
                { label: 'Veli E-posta', value: generatedCredentials.veli_email },
                { label: 'Veli Şifre', value: generatedCredentials.veli_sifre },
              ].map(item => (
                <div key={item.label} style={{ padding: '10px 12px', borderRadius: 8, background: 'var(--bg-elevated)', display: 'flex', justifyContent: 'space-between' }}>
                  <strong>{item.label}:</strong>
                  <span style={{ fontFamily: 'monospace' }}>{item.value || '—'}</span>
                </div>
              ))}
              {generatedCredentials.veli_sifre === null && (
                <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', padding: '0 4px' }}>
                  Not: Mevcut veli kaydı bağlandıysa yeni veli şifresi üretilmez.
                </div>
              )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <button className="btn btn-primary" onClick={() => setShowCredentialsModal(false)}>Tamam</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}